import { Button, Checkbox, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Typography } from "@mui/material";
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from "../../../elements";
import { useEffect, useState } from "react";
import { DeletePopUp, NoRecordFound, PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import { PermissionWrapper } from "../../../../wrappers";
import { ButtonLoader, ShowAttachments } from "../../../../shared_elements/components";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import NotesList from "../components/NotesList";
import { trackActivity } from "../../../../utils/mixpanel";
import { deleteNotesApi, getNotesApi } from "../apiService";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import { useParams } from "react-router-dom";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import NotesCRU from "../components/NotesCRU";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import { enqueueSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { getStorage } from "../../../../shared_elements/actionCreators";
import fileUpload, { getApiResponse } from "../../../../utils/fileUpload";
import FileUploadLayout from "../../../../shared_elements/components/FileUploadLayout";
import { RoleBaseAccess } from "../../../../hoc";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const NotesHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Parties`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{minWidth: '140px', whiteSpace: 'nowrap'}}>
                    <PermissionWrapper extraProps={{ application: 'lease_revamp', feature: 'notes_module', operationType: ['D'] }}>
                        <Checkbox disableRipple color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('type', 'Type')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('description', 'Description')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('remarks', 'Details')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('start_date', 'Start Date')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('end_date', 'End Date')}</TableCell>
            </TableRow>
        </TableHead>
    );
};
const Notes = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const [notesInfo, setNotesInfo] = useState({ list: [], pagination: null });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const [addEditNotes, setAddEditNotes] = useState({ mode: '', modal: false, data: null })
    const [deleteNotes, setDeleteNotes] = useState({ modal: false, data: null });
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isExport, seIsExport] = useState(false);
     const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({});

    useEffect(() => {
        const uploadedFileData = getApiResponse("lease_notes", slug);
        getNotesList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Notes' })
        setUploadFileProgressData({ uploadedFileData });
    }, [])

    const getNotesList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getNotesApi(params, query), {}).then(response => {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            if (checkApiStatus(response)) {
                setNotesInfo(response?.data?.data)
            }
        });
         dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"lease_notes"}))
    }
    const onDeleteNotes = () => {
        setLoading(true);
        const idsToDelete = deleteNotes?.modal && deleteNotes?.data?.id ? [deleteNotes?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteNotesApi(params), { ids: idsToDelete })
        .then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                trackActivity('Item Deleted', { page_title: `Delete Notes`, success_msg: response?.data?.message, item_ids: deleteNotes?.data || bulk?.ids, response: response?.data })
                setDeleteNotes({ modal: false, data: null });
                setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                getNotesList('', { per_page: notesInfo?.pagination?.per_page });
            }
            else {
                setLoading(false);
                enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                trackActivity('Item Deleted', { page_title: `Delete Notes`, error_msg: response?.data?.message, item_ids: deleteNotes?.data || bulk?.ids, response: response?.data })
            }
        });
    };

     const onDeteAttchments = (deltedslug) => {
        setUploadfileList({
            ...uploadfileList, data: {
                ...uploadfileList.data,
                attachments: uploadfileList.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditNotes?.modal) {
            setAddEditNotes({
                ...addEditNotes,
                data: {
                    ...addEditNotes.data,
                    attachments: addEditNotes.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getNotesList('', { page: notesInfo?.pagination?.current_page || 1, per_page: notesInfo?.pagination?.per_page || 50 });
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getNotesList('', { ...sortQuery, per_page: notesInfo?.pagination?.per_page });
    }
    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getNotesApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar( response?.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } } );
                seIsExport(false);
            }
        })
    }
    const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "lease_notes",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments ,response}) => {
               setUploadFileProgressData({ progressRefs, attachments ,response});
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getNotesList("fetch", { per_page: notesInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Notes`, page_type: page_type, })
    }
    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="basic" />
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Notes" type="basic" />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 6, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right' }}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "notes_module", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" color='error' size="small" >{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {notesInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} className='btn-primary action-btn-start-icon' variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button'); }}> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "notes_module", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={() => { setAddEditNotes({ modal: true, data: { type: "", description: "", remarks: "" }, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Notes</Button> </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: notesInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                                <Table className="mui-table-format" stickyHeader>
                                    <NotesHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={notesInfo?.list} toggleBulkOps={toggleBulkOps} />
                                    <TableBody>
                                        {notesInfo?.list?.length > 0 && (
                                            notesInfo.list.map((item, index) => {
                                                  const uploadedFileData = getApiResponse("lease_notes", item?.slug);
                                                return (
                                                    <NotesList
                                                        key={index}
                                                        item={item}
                                                        bulk={bulk}
                                                        slug={slug?.slug}
                                                        uploadedFileData={uploadedFileData}
                                                        uploadFileProgressData={uploadFileProgressData}
                                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        viewFile={() => setUploadfileList({ modal: true, mode: 'file', data: item })}
                                                        deleteNotes={deleteNotes}
                                                        toggleBulkOps={toggleBulkOps}
                                                        onEdit={() => setAddEditNotes({ modal: true, mode: 'edit', data: item, })}
                                                        onDelete={() => {
                                                            setDeleteNotes({ modal: true, data: item });
                                                            setBulk({modal: false, ids: [item], type: ''});
                                                        }}
                                                        onView={() => setAddEditNotes({ modal: true, mode: 'view', data: item, })}
                                                    />
                                                );
                                            })
                                        )}

                                    </TableBody>
                                </Table>
                            )}
                            {!skeletonLoader && !notesInfo?.list?.length && <NoRecordFound />}
                        </div>
                        <Paper square>
                            <Pagination
                                pagination={notesInfo?.pagination} onPageChange={(event, newPage) => { const pageNum = newPage + 1; getNotesList("Pageloader", { page: pageNum, per_page: notesInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }} onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getNotesList("Pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                            />
                        </Paper>
                    </Paper>
                </div>
            </Paper>
            {uploadfileList.modal ?
                <ShowAttachments
                    url='delete-attachment'
                    moduleName="Notes"
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode: '' })}
                    onViewDisabled={addEditNotes?.mode === 'view' || uploadfileList?.mode === 'view'}
                    permissionKey='notes_module'
                /> : null
            }
            {addEditNotes.modal ?
                <NotesCRU
                    params={params}
                    fileUpload={handleUpload}
                    notesInfo={notesInfo}
                    modeType={addEditNotes?.mode}
                    addEditNotes={addEditNotes}
                    getResponseBack={() => {getNotesList('', { per_page: notesInfo?.pagination?.per_page }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onToggleModal={() => setAddEditNotes({ modal: false, mode: '', data: null })}
                    onOpenAttachments={() => setUploadfileList({ modal: true, data: addEditNotes?.data, mode: 'view' })}
                /> : null
            }
            {deleteNotes.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteNotes.modal}
                    title={bulk?.modal ? `Delete ${bulk?.ids?.length > 0 && bulk?.ids?.length === (notesInfo?.list?.length || 0) ? "All Lease Notes" : "Selected Lease Notes"}` : "Delete Lease Note"}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => bulk.modal ? setBulk({ modal: false, ids: [] }) : setDeleteNotes({ modal: false, data: null })}
                    onDeleteRecords={() => onDeleteNotes()}
                /> : null}
            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"lease_notes"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
              />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(Notes, { application: 'lease_revamp', feature: 'notes_module', operationType: ['R'], leaseNav: true });